import { Component, OnInit, Input, Output, EventEmitter, Inject } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDialog } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../../services/language.service';

import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-filter-dialog',
  templateUrl: './filter-dialog.component.html',
  styleUrls: ['./filter-dialog.component.css']
})
export class FilterDialogComponent {
  newValue = '';

  constructor(public translate: TranslateService, public languageService: LanguageService, 
    @Inject(MAT_DIALOG_DATA) public data: {
      type: 'text' | 'date' | 'value', // Tipus de filtre
      mode?: 'ANY' | 'ALL',   // Només per text
      values?: string[],      // Només per text
      dateStart?: Date,       // Només per dates
      dateEnd?: Date,          // Només per dates
      min?: number,         // Només per numeros
      max?: number          // Només per numeros
    }
  )
  {// Inicialitzem arrays si no venen definits per evitar errors al *ngFor

    if (this.data.type === 'text' && !this.data.values) {
      this.data.values = [];
    }
  }

  addValue() {
    if (this.newValue?.trim()) {
      this.data.values.push(this.newValue.trim());
      this.newValue = '';
    }
  }

  lostFocus() {
    const type = this.data.type;

    // 1. CAS TEXT: Afegim el text pendent a la llista de chips
    if (type === 'text' && this.data.values && this.newValue?.trim()) {
     this.data.values.push(this.newValue.trim());
    }
  }

  removeValue(i: number) {
    this.data.values = [];
    this.data.dateStart = null; this.data.dateEnd = null;
    this.data.min = null; this.data.max = null;
    this.data.values.splice(i, 1);
  }

  tancar(){
    return null;
  }
}
